module.exports = __webpack_public_path__ + "assets/img/b966-id.svg";